import { FunctionComponent, memo, useMemo } from 'react';
import { EventItemUnavailable, useIsEventUnavailable } from '../../../../shared';
import { CardContainer } from '../CardContainer';
import { Content } from '../Content';
import { RightSideStoryCardProps } from '../RightSideStoryCard';

export const Event: FunctionComponent<RightSideStoryCardProps> = memo(({ card }) => {
  const isEventUnavailable = useIsEventUnavailable();

  const { event } = card;

  const eventContent = useMemo(() => {
    if (isEventUnavailable(event)) {
      return <EventItemUnavailable />;
    }

    if (!event) {
      return null;
    }

    return <Content title={event.name} htmlText={event.descriptionHTML} />;
  }, [event, isEventUnavailable]);

  return <CardContainer card={card}>{eventContent}</CardContainer>;
});
